var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm._t("default", function () {
        return [
          _c("div", { staticClass: "flex flex-col justify-between h-full" }, [
            _c("div", [_vm._t("content")], 2),
            _c("div", { staticClass: "space-y-2" }, [_vm._t("actions")], 2),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }